export default {
  laborTemplates: [],
};
